import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'

import { EInvoiceAttachment } from '../../../../../data/models'
import { DocumentList } from '../../../common'

export const DocumentsDialog: React.FC = () => {
  const { t } = useTranslation('eInvoiceHistory')
  const navigate = useNavigate()
  const location = useLocation()
  const attachments = location.state?.attachments as EInvoiceAttachment[]

  const sortedAttachments = attachments
    ? [...attachments].sort((a, b) => {
        const order: Record<string, number> = {
          ReadableInvoice: 1,
          UpdatedReadableInvoice: 2,
          XInvoice: 3,
          FacturX: 4,
          CheckReport: 5,
        }
        const orderA = order[a.DocumentType] ?? 999
        const orderB = order[b.DocumentType] ?? 999
        return orderA - orderB
      })
    : []

  const handleHide = () => {
    const pathWithoutDocuments = location.pathname.replace(
      /\/documents\/[^/]+$/,
      '',
    )
    navigate(pathWithoutDocuments)
  }

  const dialogFooter = (
    <Button
      label={t('table.documents.dialog.close.label')}
      icon="pi pi-times"
      onClick={handleHide}
      text
    />
  )

  return (
    <Dialog
      header={t('table.documents.dialog.title')}
      visible
      onHide={handleHide}
      className="p-fluid"
      breakpoints={{ '960px': '75vw', '640px': '100vw' }}
      style={{ width: '50vw' }}
      footer={dialogFooter}
      modal
    >
      <DocumentList documents={sortedAttachments} />
    </Dialog>
  )
}
